import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["rows", "rowCount", "pageSize", "pageSizeOptions", "initialState"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { DataGridPremium } from "@mui/x-data-grid-premium";
export var DynamicDataGrid = function (props) {
    var _ref;
    var rows = props.rows, rowCount = props.rowCount, _a = props.pageSize, pageSize = _a === void 0 ? 10 : _a, _b = props.pageSizeOptions, pageSizeOptions = _b === void 0 ? [5, 10, 20, 50, 100] : _b, initialState = props.initialState, other = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(DataGridPremium, _extends({
        pagination: true,
        rows: rows,
        rowCount: (_ref = rowCount !== null && rowCount !== void 0 ? rowCount : rows === null || rows === void 0 ? void 0 : rows.length) !== null && _ref !== void 0 ? _ref : 0,
        initialState: _objectSpread({
            pagination: {
                paginationModel: {
                    pageSize: pageSize
                }
            }
        }, initialState),
        pageSizeOptions: pageSizeOptions,
        rowSelection: false,
        cellSelection: true,
        disableAggregation: true
    }, other));
};
